import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { ReleaseMessageBanner } from "./styles";

const UnstyledBanner = ({ fileName, handleBannerDismiss }) => {
    //todo: processing states
    return (
        <ReleaseMessageBanner
            bannerValue={fileName}
            styleType="solid"
            infoType="neutral"
            handleDismissClick={text => {
                handleBannerDismiss(text);
            }}
            darkMode
        >
            {fileName}
        </ReleaseMessageBanner>
    );
};

const Banner = styled(UnstyledBanner)``;

Banner.propTypes = {
    fileName: PropTypes.string.isRequired,
    handleBannerDismiss: PropTypes.func.isRequired
};

export default Banner;
